import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './contexts/AuthContext'
import { ToastProvider } from './contexts/ToastContext'
import ErrorBoundary from './components/ErrorBoundary'
import ProtectedRoute from './components/ProtectedRoute'
import Header from './components/Header'
import Navigation from './components/Navigation'
import MatchesList from './pages/MatchesList'
import MatchDetail from './pages/MatchDetail'
import VodHighlightsList from './pages/VodHighlightsList'
import VodHighlightDetail from './pages/VodHighlightDetail'
import VodsList from './pages/VodsList'
import VodDetail from './pages/VodDetail'
import CompetitionsList from './pages/CompetitionsList'
import TournamentCreate from './pages/TournamentCreate'
import TournamentDetail from './pages/TournamentDetail'
import ComplexesList from './pages/ComplexesList'
import ComplexDetail from './pages/ComplexDetail'
import PlayersList from './pages/PlayersList'
import PlayerDetail from './pages/PlayerDetail'
import TeamsList from './pages/TeamsList'
import TeamDetail from './pages/TeamDetail'
import FeedMapping from './pages/FeedMapping'
import FeedsList from './pages/FeedsList'
import FeedDetail from './pages/FeedDetail'
import LiveControl from './pages/LiveControl'
import ArticleDetail from './pages/ArticleDetail'
import ArticlesList from './pages/ArticlesList'
import MvpdProvidersList from './pages/MvpdProvidersList'
import PromotionsList from './pages/PromotionsList'
import PageLayout from './pages/merchandising/PageLayout'
import WidgetLibrary from './pages/merchandising/WidgetLibrary'
import { SpeedbumpProvider } from './components'
import { WidgetSiteProvider } from './contexts/WidgetSiteContext'
import SiteSelector from './components/merchandising/SiteSelector'
import './App.scss'
import MatchBriefingPage from './pages/MatchBriefingPage'

function App() {
  return (
    <ErrorBoundary>
      <AuthProvider>
        <ToastProvider>
        <SpeedbumpProvider>
        <BrowserRouter>
          <div className="App">
            <ProtectedRoute>
              <Header />
              <Navigation />
              <main className="main-content">
                <Routes>
                  <Route path="/" element={<Navigate to="/matches" replace />} />
                  <Route path="/live" element={<LiveControl />} />
                  <Route path="/matches" element={<MatchesList />} />
                  <Route path="/matches/:matchId" element={<MatchDetail />} />
                  <Route path="/vod-highlights" element={<VodHighlightsList />} />
                  <Route path="/vod-highlights/:highlightId" element={<VodHighlightDetail />} />
                  <Route path="/vods" element={<VodsList />} />
                  <Route path="/vods/:vodId" element={<VodDetail />} />
                  <Route path="/tournaments" element={<CompetitionsList />} />
                  <Route path="/tournaments/new" element={<TournamentCreate />} />
                  <Route path="/tournaments/:tournamentId" element={<TournamentDetail />} />
                  <Route path="/players" element={<PlayersList />} />
                  <Route path="/players/:playerId" element={<PlayerDetail />} />
                  <Route path="/teams" element={<TeamsList />} />
                  <Route path="/teams/:teamId" element={<TeamDetail />} />
                  <Route path="/courts" element={<ComplexesList />} />
                  <Route path="/courts/:complexId" element={<ComplexDetail />} />
                  <Route path="/feed-mapping" element={<FeedMapping />} />
                  <Route path="/feeds" element={<FeedsList />} />
                  <Route path="/feeds/:feedId" element={<FeedDetail />} />
                  <Route path="/match-briefing" element={<MatchBriefingPage />} />
                  <Route path="/mvpd-providers" element={<MvpdProvidersList />} />
                  <Route path="/promotions" element={<PromotionsList />} />
                  <Route path="/content/*" element={
                    <WidgetSiteProvider><SiteSelector>
                      <Routes>
                        <Route path="articles" element={<ArticlesList />} />
                        <Route path="articles/:articleId" element={<ArticleDetail />} />
                        <Route path="widgets" element={<WidgetLibrary />} />
                        <Route path="page/:pageId/preview" element={<PageLayout />} />
                        <Route path="page/:pageId" element={<PageLayout />} />
                        <Route path=":pageType/preview" element={<PageLayout />} />
                        <Route path=":pageType" element={<PageLayout />} />
                        <Route path="" element={<PageLayout />} />
                      </Routes>
                    </SiteSelector></WidgetSiteProvider>
                  } />
                </Routes>
              </main>
            </ProtectedRoute>
          </div>
        </BrowserRouter>
        </SpeedbumpProvider>
        </ToastProvider>
      </AuthProvider>
    </ErrorBoundary>
  )
}

export default App
